import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import "dayjs/locale/en-gb";

// Global dayjs configuration for this package and its consumers.
// Imported for its side effects from src/index.ts so every consumer gets the
// same dayjs state regardless of which components it uses. Must stay listed in
// the "sideEffects" field of package.json, or bundlers will drop it.
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

// This locale starts weeks on Monday.
// Right now we do not really care about other locales, when we do we need to
// adjust this to be dynamic. If we want to introduce other locales we need to
// look at setEventTimes in RegistrationCalendar as well.
dayjs.locale("en-gb");
